import { render, staticRenderFns } from "./layout-select.vue?vue&type=template&id=307d41c8&"
import script from "./layout-select.vue?vue&type=script&lang=js&"
export * from "./layout-select.vue?vue&type=script&lang=js&"
import style0 from "./layout-select.vue?vue&type=style&index=0&id=307d41c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports